import {StyleSheet} from 'react-native';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getMediaType} from './utils';
import AudioPlayer from './AudioPlayer';
import {selectAslType} from '../../redux/slices/AslSlice';
import ASLVideoItem from './ASLVideoItem';

const Asl = props => {
   const dispatch = useDispatch();
   const fileType = useSelector(selectAslType);
   useEffect(() => {
      getMediaType(props?.url, dispatch);
   }, []);

   if (fileType === 'audio') {
      return <AudioPlayer type={fileType} dispatch={dispatch} {...props} />;
   }
   return <ASLVideoItem type={fileType} dispatch={dispatch} {...props} />;
   //return <VideoPlayer />;
};

const style = StyleSheet.create({
   container: {
      width: 40,
      height: 40,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
   },
   item: {
      alignItems: 'center',
      alignSelf: 'center',
      justifyContent: 'center',
      height: 30,
      width: 30,
      borderRadius: 16,
      marginLeft: 8,
   },
   card: {
      width: '90%',
      height: 100,
      backgroundColor: '#FFF',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 10,
      marginBottom: 10,
      elevation: 5,
      zIndex: 999,
   },
});
export default Asl;
